var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.direction},[_c('img',{staticClass:"hot-offer-badge",attrs:{"src":(_vm.color && _vm.text) ? `/assets/img/hot-offer-${_vm.color}.png`: '/assets/img/hot-offer.png'}}),_c('p',{staticClass:"badge-text",class:{'multi-row' : _vm.text.includes(' ')}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }